module.exports = __webpack_public_path__ + "static/media/violet.090f7b25.png";